export default function NameInitials(val1) {
    return val1.charAt(0)
}